(function () {
  'use strict';

  angular
    .module('targetHours')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('targetHours', {
        url: '/target-hours',
        views : {
			'targetHourView' : {
			    templateUrl : 'target-hours/views/target-hours.tpl.html',
				controller : 'TargetHoursCtrl',
				controllerAs : 'targetHours'
					}
				}
      });
  }
}());
